import { createSelector } from 'reselect'

const getAdvocates = (state) => state.advocate

export const selectActions = createSelector(
  [getAdvocates],
  (advocate) => advocate.actions
)

export const selectEncounters = createSelector(
  [getAdvocates],
  advocate => advocate.encounters,
);

export const selectBullets = createSelector(
  [getAdvocates],
  (advocate) => advocate.bullets
)

export const selectMedications = createSelector(
  [getAdvocates],
  (advocate) => advocate.medications
)



// WEBPACK FOOTER //
// ./src/store/advocate-dashboard/AdvocateSelectors.js